// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as $$History from "history";
import * as Core__Dict from "@rescript/core/src/Core__Dict.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as RelayRouter__Context from "./RelayRouter__Context.mjs";
import * as RelayRouter__Bindings from "./RelayRouter__Bindings.mjs";
import * as RelayRouter__Internal from "./RelayRouter__Internal.mjs";
import * as ReactRouterJs from "./vendor/react-router.js";

function prepareMatches(matches, environment, queryParams, $$location) {
  return matches.map(function (match) {
              var match$1 = match.route.prepare(environment, match.params, queryParams, $$location, "Render");
              return {
                      routeKey: match$1.routeKey,
                      render: match$1.render
                    };
            });
}

function makeBrowserEnvironment() {
  return $$History.createBrowserHistory();
}

function makeServerEnvironment(initialUrl) {
  return $$History.createMemoryHistory({
              initialEntries: [initialUrl]
            });
}

var RouterEnvironment = {
  makeBrowserEnvironment: makeBrowserEnvironment,
  makeServerEnvironment: makeServerEnvironment
};

function make(routes, history, environment, preloadAsset) {
  var routerEventListeners = {
    contents: []
  };
  var postRouterEvent = function ($$event) {
    routerEventListeners.contents.forEach(function (cb) {
          cb($$event);
        });
  };
  var $$location = history.location;
  var initialQueryParams = RelayRouter__Bindings.QueryParams.parse($$location.search);
  var initialMatches = Core__Option.getOr(Caml_option.nullable_to_opt(ReactRouterJs.matchRoutes(routes, $$location)), []);
  initialMatches.forEach(function (param) {
        var route = param.route;
        preloadAsset("High", {
              TAG: "Component",
              _0: {
                __$rescriptChunkName__: route.__$rescriptChunkName__,
                load: (function () {
                    route.loadRouteRenderer();
                  })
              }
            });
      });
  var preparedMatches = prepareMatches(initialMatches, environment, initialQueryParams, $$location);
  var currentEntry = {
    contents: {
      location: $$location,
      preparedMatches: preparedMatches
    }
  };
  var nextId = {
    contents: 0
  };
  var subscribers = {};
  var nextNavigationIsShallow = {
    contents: false
  };
  var cleanup = history.listen(function (param) {
        var $$location = param.location;
        var thisNavigationShouldBeShallow = nextNavigationIsShallow.contents;
        if (nextNavigationIsShallow.contents === true) {
          nextNavigationIsShallow.contents = false;
        }
        if (!(!thisNavigationShouldBeShallow && ($$location.pathname !== currentEntry.contents.location.pathname || $$location.search !== currentEntry.contents.location.search))) {
          return ;
        }
        var queryParams = RelayRouter__Bindings.QueryParams.parse($$location.search);
        var currentMatches = currentEntry.contents.preparedMatches;
        var matches = Core__Option.getOr(Caml_option.nullable_to_opt(ReactRouterJs.matchRoutes(routes, $$location)), []);
        var preparedMatches = prepareMatches(matches, environment, queryParams, $$location);
        currentEntry.contents = {
          location: $$location,
          preparedMatches: preparedMatches
        };
        currentMatches.forEach(function (param) {
              var routeKey = param.routeKey;
              if (Core__Option.isNone(preparedMatches.find(function (match) {
                          return match.routeKey === routeKey;
                        }))) {
                return postRouterEvent({
                            TAG: "OnRouteWillUnmount",
                            routeKey: routeKey
                          });
              }
              
            });
        Object.values(subscribers).forEach(function (subscriber) {
              subscriber(currentEntry.contents);
            });
      });
  var runOnEachRouteMatch = function (preloadUrl, cb) {
    var fullUrl = window.location.origin + preloadUrl;
    var url = new URL(fullUrl);
    var queryParams = RelayRouter__Bindings.QueryParams.parse(Core__Option.getOr(url.search, ""));
    var location_pathname = url.pathname;
    var location_search = Core__Option.getOr(url.search, "");
    var location_hash = url.hash;
    var location_state = url.state;
    var $$location = {
      pathname: location_pathname,
      search: location_search,
      hash: location_hash,
      state: location_state,
      key: "-"
    };
    Core__Option.getOr(Caml_option.nullable_to_opt(ReactRouterJs.matchRoutes(routes, $$location)), []).forEach(function (match) {
          cb(match, queryParams, $$location);
        });
  };
  var preloadCode = function (priorityOpt, preloadUrl) {
    var priority = priorityOpt !== undefined ? priorityOpt : "Default";
    runOnEachRouteMatch(preloadUrl, (function (match, queryParams, param) {
            RelayRouter__Internal.runAtPriority((function () {
                    match.route.preloadCode(environment, match.params, queryParams, $$location).then(function (assetsToPreload) {
                          assetsToPreload.forEach(function (a) {
                                preloadAsset(priority, a);
                              });
                          return Promise.resolve();
                        });
                  }), priority);
          }));
  };
  var preload = function (priorityOpt, preloadUrl) {
    var priority = priorityOpt !== undefined ? priorityOpt : "Default";
    runOnEachRouteMatch(preloadUrl, (function (match, queryParams, $$location) {
            RelayRouter__Internal.runAtPriority((function () {
                    match.route.prepare(environment, match.params, queryParams, $$location, "Preload");
                  }), priority);
          }));
  };
  var get = function () {
    return currentEntry.contents;
  };
  var subscribe = function (cb) {
    nextId.contents = nextId.contents + 1 | 0;
    var id = nextId.contents;
    subscribers[id.toString()] = cb;
    return function () {
      Core__Dict.$$delete(subscribers, id.toString());
    };
  };
  var markNextNavigationAsShallow = function () {
    nextNavigationIsShallow.contents = true;
  };
  return [
          cleanup,
          {
            preload: preload,
            preloadCode: preloadCode,
            preloadAsset: preloadAsset,
            get: get,
            subscribe: subscribe,
            history: history,
            subscribeToEvent: (function (callback) {
                routerEventListeners.contents.push(callback);
                return function () {
                  routerEventListeners.contents = routerEventListeners.contents.filter(function (cb) {
                        return cb !== callback;
                      });
                };
              }),
            postRouterEvent: postRouterEvent,
            markNextNavigationAsShallow: markNextNavigationAsShallow
          }
        ];
}

var Router = {
  make: make
};

function RelayRouter$RouteComponent(props) {
  return props.render(props.children);
}

function RelayRouter$RouteRenderer(props) {
  var renderPending = props.renderPending;
  var router = RelayRouter__Context.useRouterContext();
  var match = React.useTransition();
  var startTransition = match[1];
  var isPending = match[0];
  var match$1 = React.useState(function () {
        return router.get();
      });
  var setRouteEntry = match$1[1];
  var routeEntry = match$1[0];
  if (!import.meta.env.SSR) {
    React.useLayoutEffect((function () {
            if (!isPending) {
              router.postRouterEvent({
                    TAG: "RestoreScroll",
                    _0: routeEntry.location
                  });
            }
            
          }), [isPending]);
  }
  React.useEffect((function () {
          return router.subscribe(function (nextRoute) {
                      startTransition(function () {
                            setRouteEntry(function (param) {
                                  return nextRoute;
                                });
                          });
                    });
        }), [
        router,
        startTransition
      ]);
  var reversedItems = routeEntry.preparedMatches.toReversed();
  var renderedContent = {
    contents: null
  };
  reversedItems.forEach(function (param) {
        renderedContent.contents = JsxRuntime.jsx(RelayRouter$RouteComponent, {
              render: param.render,
              children: renderedContent.contents
            });
      });
  return JsxRuntime.jsxs(RelayRouter__Internal.RouterTransitionContext.Provider.make, {
              value: startTransition,
              children: [
                renderPending !== undefined ? renderPending(isPending) : null,
                renderedContent.contents
              ]
            });
}

var RouteRenderer = {
  make: RelayRouter$RouteRenderer
};

function useRegisterPreloadedAsset(asset) {
  var match = RelayRouter__Context.useRouterContext();
  try {
    if (import.meta.env.SSR) {
      return match.preloadAsset("Default", asset);
    } else {
      return ;
    }
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return ;
    }
    throw exn;
  }
}

var Types;

var Bindings;

var Link;

var Scroll;

var AssetPreloader;

var NetworkUtils;

var PreloadInsertingStream;

var Manifest;

var $$History$1;

var Internal;

var Utils;

var Provider = RelayRouter__Context.Provider;

var useRouterContext = RelayRouter__Context.useRouterContext;

export {
  Types ,
  Bindings ,
  Link ,
  Scroll ,
  AssetPreloader ,
  NetworkUtils ,
  PreloadInsertingStream ,
  Manifest ,
  $$History$1 as $$History,
  Internal ,
  Utils ,
  RouterEnvironment ,
  Router ,
  Provider ,
  useRouterContext ,
  RouteRenderer ,
  useRegisterPreloadedAsset ,
}
/* react Not a pure module */
